import h from 'virtual-dom/h'
import VText from 'virtual-dom/vnode/vtext'

export default class Renderers
{
    constructor(settings)
    {
        this._settings = settings;
    }

    initialize(store, mutators, childRenderers)
    {
        this._mutators = mutators;
        this._childRenderers = childRenderers;
        this._store = store;
    }

    getRender()
    {
        return () =>
        {
            let parameters = {
                className : this._settings.classNames.bannerClassName,
                attributes:{
                    id : this._settings.classNames.bannerClassName
                }
            };

            let parametersSubHeader = {
                className : this._settings.classNames.subbannerClassName,
                attributes:{
                    id : this._settings.classNames.subbannerClassName
                }
            };

            let windowLoc = this._settings.stateLocations.Window;
            let windowState = this._store.getState()[windowLoc.Base];
            let bannerText = (windowLoc.bannerText != null && windowState[windowLoc.bannerText] != null) ? 
                             windowState[windowLoc.bannerText] :
                             this._settings.textConstants.bannerText;

            let childNode = new VText(bannerText);
            this._mutators.forEach((mutate) => {
                parameters = mutate(parameters);
            });

            let childNodes = [childNode];

            this._childRenderers.forEach((render) => {
                childNodes.push(render());
            });

            let subchildNode = new VText(this._settings.textConstants.subBannerText);

            let subChildNodes = [subchildNode];

            this._childRenderers.forEach((render) => {
                subChildNodes.push(render());
            });
            const subHeaderElement = h('span', parametersSubHeader, subChildNodes);
            childNodes.push(subHeaderElement);
            
            return h('h2', parameters, childNodes);
        };
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-header-banner/src/renderers/renderers.js